<template>
  <div>
    <div class="relative h-0 pb-3/4 @parallaxWrapperClass">
      <a
        v-if="model.linkUrl"
        v-bind="linkAttributes"
      >
        <Picture
          v-bind="model.image"
          :mobile="[460, 345]"
          lazy
          width="460"
          height="345"
          img-class="absolute top-0 left-0 w-full h-full object-cover  @parallaxVisualClass"
        />
      </a>
      <Picture
        v-else
        v-bind="model.image"
        :mobile="[460, 345]"
        lazy
        width="460"
        height="345"
        img-class="absolute top-0 left-0 w-full h-full object-cover  @parallaxVisualClass"
      />
      <div
        v-if="model.video"
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      >
        <VideoOverlayTrigger
          :video="model.video"
        />
      </div>
    </div>
    <div
      v-if="model.subTitle"
      class="text-xs mt-6"
    >
      {{ model.subTitle }}
    </div>
    <div
      v-if="model.title"
      class="font-semibold mt-2"
    >
      {{ model.title }}
    </div>
    <div
      v-if="model.text"
      class="text-sm mt-4"
    >
      {{ model.text }}
    </div>

    <div
      v-if="model.linkUrl"
      class="text-sm mt-4"
    >
      <a
        v-bind="linkAttributes"
        class="action"
      >
        <span>{{ model.linkText }}</span>
        <span class="icon-arrow-right text-xs ml-2" />
        <span class="icon-arrow-left text-xs mr-2" />
      </a>
    </div>
  </div>
</template>

<script>
import VideoOverlayTrigger from '@/components/VideoOverlayTrigger.vue'
import Picture from '@/components/Picture.vue'

export default {
  components: {
    VideoOverlayTrigger,
    Picture
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    linkAttributes() {
      const {
        linkUrl,
        openInNewWindow
      } = this.model
      const model = {
        href: linkUrl,
        target: openInNewWindow ? '_blank' : '_self'
      }
      if (openInNewWindow) {
        model.rel = 'noopener noreferrer'
      }

      return model
    }
  }
}
</script>
